import { service } from '@ember/service';
import Controller from '@ember/controller';

export default class ApplicationErrorController extends Controller {
  @service currentPractice;
}
